export { default } from './InputWithOptions.js';
